import { Box, CircularProgress } from '@mui/material';

export const LoadingProgress = () => (
  <Box display="flex" flex={1} alignItems="center" justifyContent="center">
    <CircularProgress />
  </Box>
);
